
        var result = require("!!../../../../node_modules/css-loader/index.js!./resources.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/resources/resources.component.css
// module id = 1221
// module chunks = 0